import React from "react";
import ReactPaginate from "react-paginate";

interface PaginationProps {
  pagination: {
    page: number;
    limit: number;
    count: number;
  };
  onPageChange: (selectedPage: { selected: number }) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  pagination,
  onPageChange,
}) => {
  return (
    <div className="paginationbox">
      <div className="pagina-title">
        <p>
          Showing{" "}
          {pagination.page === 0
            ? 0
            : (pagination.page - 1) * pagination.limit + 1}{" "}
          to {Math.min(pagination.page * pagination.limit, pagination.count)}{" "}
          out of {pagination.count} entries
        </p>
      </div>
      <div className="pagina-number">
        <ReactPaginate
          pageCount={Math.ceil(pagination.count / pagination.limit)}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          previousLabel={"Previous"}
          nextLabel={"Next"}
          breakLabel={"..."}
          onPageChange={onPageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
};

export default Pagination;
